"use client";
import { useGetCartQuery } from "@/api/AppApi/services/cart";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import Separator from "@/app/components/lib/Separator";
import CartEmpty from "@/app/components/pages-components/cart/CartEmpty";
import AllCartItems from "@/app/components/pages-components/cart/all-cart-items/AllCartItems";
import { useDimensions } from "@/hooks/dim-hook";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { Row } from "@/utils/bootstrap";
import { atom, useAtom } from "jotai";
import { useEffect } from "react";
import HoverDropDown from "../../../header-common/menu/pc/HoverDropDown";
import CartMenuBtns from "./CartMenuBtns";
import SvgPcCart from "./SvgPcCart";

export const cartXAtom = atom(0);

const PcCartMenu = () => {
  const t = useTranslation();
  const [, setCartX] = useAtom(cartXAtom);
  const [ref, dimensions] = useDimensions();
  const company = useGetCompanyQuery();
  const getCart = useGetCartQuery();
  const items = getCart.data?.result?.items;
  const itemCount = items?.length ?? 0;
  const showTax = company.data?.result.theme.components.product.enable_taxes;

  const itemsTax = items?.reduce((acc, val) => acc + val.tax * val.quantity, 0);
  const tax = showTax ? itemsTax : undefined;
  useEffect(() => {
    setCartX(dimensions?.x);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dimensions]);
  // if (getCart.isLoading) return <GeneralApiLoader />;

  return (
    <div ref={ref}>
      <HoverDropDown
        reversed
        down
        title={
          <div className={`pc-cart-btn ${itemCount === 0 ? "empty" : "full"}`}>
            <SvgPcCart />
            {itemCount !== 0 && (
              <span style={{ marginInlineStart: 8 }}>{itemCount}</span>
            )}
            <span className="hide-to-vistor">
              {itemCount === 0 ? t.cart_items : `${t.cart_items} (${itemCount})`}
            </span>
          </div>
        }
      >
        <Row>
          <div style={{ width: "fit-content" }}>
            {itemCount === 0 ? (
              <CartEmpty menu />
            ) : (
              <div className="cart-menu">
                <Separator startLabel={t.cart_items} />
                <Row
                  style={{
                    maxHeight: 320,
                    overflow: "hidden auto",
                    marginBottom: 16,
                  }}
                >
                  <AllCartItems cartItems={items ?? []} menu />
                </Row>
                <CartMenuBtns
                  total={getCart?.data?.result?.total ?? 0}
                  tax={tax}
                />
              </div>
            )}
          </div>
        </Row>
      </HoverDropDown>
    </div>
  );
};

export default PcCartMenu;
